export enum Features {
  ManageOwnPermissions = 'ManageOwnPermissions',
  DashboardScreen = 'DashboardScreen',
  ExecutionHistoryScreen = 'ExecutionHistoryScreen',
  ExecutionHistoryScreen_Details = 'ExecutionHistoryScreen_Details',
  ExceptionHistoryScreen = 'ExceptionHistoryScreen',
  ExceptionHistoryScreen_Details = 'ExceptionHistoryScreen_Details',
  ReportsScreen = 'ReportsScreen',
  CompareEmailsScreen = 'CompareEmailsScreen',
  CompareEmail = 'CompareEmail',
  TestingToolScreen = 'TestingToolScreen',
  ReprocessEmail = 'ReprocessEmail',
  AllowListScreen = 'AllowListScreen',
  CacheReloaderScreen = 'CacheReloaderScreen',
  AuditLogScreen = 'AuditLogScreen',
  MktFeature_CustomChannelScreens = 'MktFeature_CustomChannelScreens',
  MktFeature_EmailPreview = 'MktFeature_EmailPreview',
  MktFeature_ShowUserIdOnExecutionDetails = 'MktFeature_ShowUserIdOnExecutionDetails',
  MktFeature_ReprocessExecution = 'MktFeature_ReprocessExecution',
  MktFeature_ResendEmail = 'MktFeature_ResendEmail',
  MktFeature_HasSharedId = 'MktFeature_HasSharedId',
  MktFeature_LanguageSelectorOnTestingTool = 'MktFeature_LanguageSelectorOnTestingTool',
  MktFeature_UsesPublishAPI = 'MktFeature_UsesPublishAPI',
  MktFeature_HasMultipleCountry = 'MktFeature_HasMultipleCountry',
  MktFeature_Health_AmwayProfile = 'MktFeature_Health_AmwayProfile',
  MktFeature_Health_Exponea = 'MktFeature_Health_Exponea',
  MktFeature_Health_OrderLookupAPI = 'MktFeature_Health_OrderLookupAPI',
  MktFeature_Health_ProductInfoAPI = 'MktFeature_Health_ProductInfoAPI',
  MktFeature_Health_VolumeAPI = 'MktFeature_Health_VolumeAPI',
  MktFeature_Health_Uplines = 'MktFeature_Health_Uplines',
  MktFeature_Health_Docgen = 'MktFeature_Health_Docgen',
  MktFeature_Health_PublisherAPI = 'MktFeature_Health_PublisherAPI',
  MktFeature_Health_NGCOrderDetailAPI = 'MktFeature_Health_NGCOrderDetailAPI',
  MktFeature_Health_NGCReturnDetailAPI = 'MktFeature_Health_NGCReturnDetailAPI',
  MktFeature_Health_NGCAccountDetailsAPI = 'MktFeature_Health_NGCAccountDetailsAPI',
  MktFeature_Health_NGCAccountMappingsAPI = 'MktFeature_Health_NGCAccountMappingsAPI',
  MktFeature_Health_NGCAccountsByProfileIdAPI = 'MktFeature_Health_NGCAccountsByProfileIdAPI',
  MktFeature_Health_NGCPaymentsAPI = 'MktFeature_Health_NGCPaymentsAPI',
  MktFeature_Health_NGCProfileByPartyIdAPI = 'MktFeature_Health_NGCProfileByPartyIdAPI',
  MktFeature_Health_NGCProfileAPI = 'MktFeature_Health_NGCProfileAPI',
  MktFeature_Health_NGCUserAPI = 'MktFeature_Health_NGCUserAPI',
  MktFeature_Health_NGCAccountEmailsAPI = 'MktFeature_Health_NGCAccountEmailsAPI',
  MktFeature_Health_NGCAccountPhonesAPI = 'MktFeature_Health_NGCAccountPhonesAPI',
  MktFeature_Health_NGCAnonymousDeliveryTrackingAPI = 'MktFeature_Health_NGCAnonymousDeliveryTrackingAPI',
  TranslationsScreen = 'TranslationsScreen',
}
